import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      fontWeight: 600,
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
      color: palette.title.primary
    },
    emoji: {
      width: '24px',
      marginLeft: '10px'
    },
    text: {
      margin: '0'
    },
    legend: {
      display: 'flex',
      flexDirection: 'column',
      gap: '5px',
      fontWeight: 500,
      color: palette.text.secondary,
      fontSize: '0.875rem'
    },
    legendTitle: {
      fontWeight: 600,
      marginBottom: '5px'
    },
    legendLine: {
      display: 'flex',
      gap: '5px',
      flexWrap: 'wrap'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
